import { useEffect, useState } from "react";
import { Clock } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

export function IdleTimeoutWarning() {
  const { showIdleWarning, refreshSession, logout } = useAuth();
  const [seconds, setSeconds] = useState(120);

  useEffect(() => {
    if (!showIdleWarning) {
      setSeconds(120);
      return;
    }
    setSeconds(120);
    const iv = setInterval(() => {
      setSeconds((s) => (s > 0 ? s - 1 : 0));
    }, 1000);
    return () => clearInterval(iv);
  }, [showIdleWarning]);

  if (!showIdleWarning) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-forest-900/40 backdrop-blur-sm p-4"
      role="dialog"
      aria-modal="true"
      data-testid="idle-warning-modal"
    >
      <div className="patria-card w-full max-w-md p-7 animate-fade-up">
        <div className="flex items-center gap-3">
          <span className="inline-flex h-11 w-11 items-center justify-center rounded-full bg-terracotta-500/10 text-terracotta-500">
            <Clock strokeWidth={1.5} />
          </span>
          <h3 className="text-2xl font-serif text-forest-900">Are You Still There?</h3>
        </div>
        <p className="mt-4 text-sm text-charcoal-soft leading-relaxed">
          For your security, MyPatria will sign you out after 30 minutes of inactivity.
          You will be signed out in <span className="font-semibold text-forest-800">{seconds}s</span>.
        </p>
        <div className="mt-6 flex flex-col sm:flex-row-reverse gap-3">
          <button
            className="patria-btn-primary sm:ml-auto"
            onClick={() => refreshSession()}
            data-testid="idle-warning-continue"
          >
            Keep me signed in
          </button>
          <button
            className="patria-btn-secondary"
            onClick={() => logout()}
            data-testid="idle-warning-signout"
          >
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
}
